// extracted by mini-css-extract-plugin
export default {"badge":"role_status_badge-module___badge___bd7cc2f8"};